import {createAction, createReducer} from 'redux-act';
import {ErrorsType} from './errors.types';
import {setErrorVisibility} from 'features/wizardMs/actions/prescription/errors';

export type ClearErrorType = {
    eye: string;
    parameter: string;
};

export const initialState: ErrorsType = {
    od: {
        sph: '',
        cyl: '',
        axi: '',
        add: '',
    },
    os: {
        sph: '',
        cyl: '',
        axi: '',
        add: '',
    },
    pd: {
        right: '',
        left: '',
    },
    isErrorVisible: false,
};

export const setErrors = createAction<Omit<ErrorsType, 'isErrorVisible'>>(
    'PRESCRIPTION_SET_ERRORS',
);
export const clearError = createAction<ClearErrorType>('CLEAR_ERROR');

export const errors = createReducer({}, initialState)
    .on(
        setErrors,
        (state: ErrorsType, payload): ErrorsType => {
            return {
                ...state,
                ...payload,
            };
        },
    )
    .on(
        clearError,
        (state, {eye, parameter}: ClearErrorType): ErrorsType => {
            return {
                ...state,
                [eye]: {
                    ...state[eye],
                    [parameter]: '',
                },
            };
        },
    )
    .on(
        setErrorVisibility,
        (state, value: boolean): ErrorsType => ({...state, isErrorVisible: value}),
    );
